/* ============================================================
   CERRAR, SIEMPRE.
   Ninguna respuesta termina en punto final: termina en el siguiente
   paso. Y cuando alguien pregunta por un tema —"quiero uno de Star
   Wars"— no se le contesta con un artículo: se le lleva al catálogo.
   ============================================================ */

var WA_NUM = "525519290505";
var WA_URL = "https://wa.me/" + WA_NUM;

/* En escritorio se abre WhatsApp Web, que es donde la gente ya tiene la sesión;
   en el teléfono, la app. wa.me decide solo, pero en escritorio a veces manda a
   una pantalla intermedia: web.whatsapp.com entra directo a la conversación. */
function enMovil(){
  return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent) || window.innerWidth < 768;
}
function waTexto(t){
  var q = t ? encodeURIComponent(t) : "";
  return enMovil()
    ? "https://wa.me/" + WA_NUM + (q ? "?text=" + q : "")
    : "https://web.whatsapp.com/send?phone=" + WA_NUM + (q ? "&text=" + q : "");
}

/* --- EL WHATSAPP SE REPARTE ENTRE DOS VENDEDORES ---
   Jaime, 2026-08-25: "que no siempre mande al mismo whatsapp para que los
   vendedores sean diferentes". Se alterna una y una entre el 55 6430 6706 y
   el 55 1929 0505.

   El turno lo lleva el ERP, contando los repartos que ya hizo, porque un
   contador aquí en el navegador empezaría de cero en cada visitante y todos
   los primeros clics caerían en la misma persona.

   SE ASIGNA POR VISITA, NO POR CLIC: se guarda mientras dure la visita, para
   que quien vuelva a tocar el botón caiga con LA MISMA persona. Cambiar de
   vendedor a mitad de una conversación es peor que repartir mal.

   Los enlaces se escriben con WA_NUM y después se reescriben todos al número
   que tocó. Así da igual de dónde venga el enlace: del HTML de una sección,
   de un cierre de venta o de una respuesta del agente. */
var WA_NUMEROS = ["525564306706", "525519290505"];
var WA_ASIGNADO = null;

function aFlotante(raiz){
  var destino = WA_ASIGNADO || WA_NUM;
  if (!raiz || !raiz.querySelectorAll) return raiz;
  var enlaces = raiz.querySelectorAll('a[href*="wa.me/"], a[href*="whatsapp.com/send"]');
  for (var i = 0; i < enlaces.length; i++){
    var h = enlaces[i].getAttribute("href");
    if (!h) continue;
    for (var j = 0; j < WA_NUMEROS.length; j++){
      if (h.indexOf(WA_NUMEROS[j]) >= 0 && WA_NUMEROS[j] !== destino){
        h = h.split(WA_NUMEROS[j]).join(destino);
      }
    }
    if (h !== enlaces[i].getAttribute("href")) enlaces[i].setAttribute("href", h);
  }
  return raiz;
}

/* Pregunta al ERP a quién le toca, una vez por visita. Si no contesta, se echa
   a suertes aquí mismo: quedarse sin WhatsApp es peor que repartir mal. */
function pideVendedor(){
  try {
    var guardado = sessionStorage.getItem("kb-wa");
    if (guardado && WA_NUMEROS.indexOf(guardado) >= 0){ WA_ASIGNADO = guardado; return Promise.resolve(guardado); }
  } catch (e) {}
  var API = window.KB_API || "https://sistema.sacher.com.mx/api/v1/public/kb";
  return fetch(API + "/vendedor", {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ url: location.pathname })
  })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(j){
      var n = j && j.numero;
      if (WA_NUMEROS.indexOf(n) < 0) n = WA_NUMEROS[Math.random() < 0.5 ? 0 : 1];
      WA_ASIGNADO = n;
      try { sessionStorage.setItem("kb-wa", n); } catch (e) {}
      return n;
    })
    .catch(function(){
      WA_ASIGNADO = WA_NUMEROS[Math.random() < 0.5 ? 0 : 1];
      return WA_ASIGNADO;
    });
}

/* --- El cierre por capítulo. Cada artículo puede pisarlo con el suyo. --- */
var CTA_CAT = {
  pedidos:  { t:"¿Listo para encargar?", d:"El catálogo está abierto a cualquier hora y el calendario ya solo te ofrece fechas que alcanzan.",
              a:[["Ver el catálogo","/collections/all","primario"],["Pedir por WhatsApp",waTexto("Hola, quiero hacer un pedido."),"secundario"]] },
  tamanos:  { t:"Elige el tuyo por número de personas", d:"En cada pastel del catálogo eliges las porciones y el precio se ajusta solo.",
              a:[["Ver pasteles","/collections/all","primario"],["Que me asesoren",waTexto("Hola, no sé qué tamaño de pastel necesito."),"secundario"]] },
  entregas: { t:"Tu pastel puede llegar a tu puerta", d:"Elige fecha y horario en el carrito; el costo de envío aparece antes de pagar.",
              a:[["Empezar mi pedido","/collections/all","primario"],["Preguntar por mi zona",waTexto("Hola, quiero saber si entregan en mi dirección."),"secundario"]] },
  tiendas:  { t:"Recoge sin pagar envío", d:"Compra en línea y pasa por él a Extremadura, Portales o Tepeyac.",
              a:[["Ver el catálogo","/collections/all","primario"],["Ver sucursales","/pages/sucursales","secundario"]] },
  pagos:    { t:"Cuando quieras, cerramos tu pedido", d:"Te mandamos el folio, el total y los datos para pagar.",
              a:[["Hacer mi pedido","/collections/all","primario"],["Escribir por WhatsApp",waTexto("Hola, quiero cerrar mi pedido."),"secundario"]] },
  cambios:  { t:"¿Necesitas mover algo?", d:"Entre antes nos escribas, más margen hay. Ten tu folio a la mano.",
              a:[["Escribir por WhatsApp",waTexto("Hola, necesito revisar mi pedido. Mi folio es: "),"primario"]] },
  cuidado:  { t:"¿Ya tienes tu pastel para la fecha?", d:"Si todavía no, el catálogo está abierto y el calendario te dice qué días alcanzan.",
              a:[["Ver pasteles","/collections/all","primario"],["Preguntar algo más",waTexto("Hola, tengo una duda sobre mi pastel."),"secundario"]] },
  eventos:  { t:"Agenda tu cita de degustación", d:"Se prueban sabores, se ve el diseño y sale una cotización a la medida.",
              a:[["Agendar cita",waTexto("Hola, quiero agendar una cita de degustación para mi evento."),"primario"],["Ver pasteles de boda","/collections/boda","secundario"]] },
  marca:    { t:"Conoce lo que hacemos", d:"Veintisiete años de oficio caben mejor en un catálogo que en un texto.",
              a:[["Ver el catálogo","/collections/all","primario"],["Leer nuestra historia","/pages/historia","secundario"]] }
};

/* --- Cierres a la medida, donde el genérico se queda corto. --- */
var CTA_ART = {
  "personalizar": { t:"Manda tu idea y te decimos qué se puede", d:"Una foto, un boceto o una descripción bastan para empezar. Mínimo 4 kilos en decorados a la medida.",
    a:[["Mandar mi diseño por WhatsApp",waTexto("Hola, quiero un pastel personalizado. Les mando mi idea:"),"primario"],["Ver diseños del catálogo","/collections/all","secundario"]] },
  "anticipacion": { t:"Aparta tu fecha antes de que se llene", d:"El calendario del carrito te muestra qué días alcanzan para lo que llevas.",
    a:[["Elegir mi pastel y mi fecha","/collections/all","primario"],["Preguntar por una fecha apretada",waTexto("Hola, necesito un pastel para una fecha próxima. ¿Alcanzan?"),"secundario"]] },
  "eventos-cotizacion": { t:"Empecemos por la degustación", d:"Es donde se prueba, se decide y se cotiza. Sin compromiso.",
    a:[["Agendar mi cita",waTexto("Hola, quiero agendar una cita de degustación. Mi evento es el:"),"primario"],["Ver pasteles de boda","/collections/boda","secundario"],["Ver pasteles de XV","/collections/xv-anos","secundario"]] },
  "corporativo": { t:"Cuéntanos el proyecto", d:"Volumen, logotipo, entregas programadas y factura a nombre de la empresa.",
    a:[["Pedir cotización",waTexto("Hola, busco pasteles para un evento de empresa."),"primario"],["Ver pasteles corporativos","/collections/corporativos","secundario"]] },
  "combinar-sabores": { t:"Prueba antes de decidir", d:"En pedidos de evento se agenda degustación: es la única forma honesta de elegir un sabor.",
    a:[["Agendar degustación",waTexto("Hola, quiero agendar una degustación de sabores."),"primario"],["Ver la carta de sabores","/pages/sabores","secundario"]] },
  "sabores-disponibilidad": { t:"Aparta el sabor que quieres", d:"Con dos días de anticipación lo tenemos listo en la sucursal que elijas.",
    a:[["Pedir mi sabor",waTexto("Hola, quiero apartar un pastel de un sabor específico."),"primario"],["Ver sabores","/pages/sabores","secundario"]] },
  "fondant": { t:"Míralo en los diseños", d:"El fondant es lo que hace posible cada acabado del catálogo. También lo vendemos suelto.",
    a:[["Ver pasteles de diseño","/collections/all","primario"],["Comprar fondant","/collections/fondant","secundario"]] },
  "envio-costo": { t:"Calcula tu envío en un minuto", d:"Agrega tu pastel al carrito y captura tu dirección: el costo aparece antes de pagar.",
    a:[["Elegir mi pastel","/collections/all","primario"],["Preguntar por mi zona",waTexto("Hola, ¿entregan en mi dirección?"),"secundario"]] },
  "sucursales-que-no-son": { t:"Compra donde sí somos nosotros", d:"Extremadura, Portales y Tepeyac. Y la tienda en línea, que es la misma casa.",
    a:[["Ver el catálogo","/collections/all","primario"],["Ver nuestras sucursales","/pages/sucursales","secundario"]] },
  "temporada": { t:"No te quedes fuera de la temporada", d:"Estas piezas se agotan y la agenda se cierra semanas antes.",
    a:[["Ver productos de temporada","/collections/pasteles-de-temporada","primario"],["Preguntar disponibilidad",waTexto("Hola, quiero saber si ya está disponible el producto de temporada."),"secundario"]] },
  "alergenos": { t:"Cuéntanos tu caso antes de pedir", d:"Preferimos revisarlo contigo a prometerte algo que no podamos sostener.",
    a:[["Consultar mi caso",waTexto("Hola, tengo una restricción alimentaria y quiero saber qué opciones hay."),"primario"]] },
  "un-piso": { t:"Te proponemos una opción a tu medida", d:"Dinos cuántas personas son y te mostramos diseños pensados para ese tamaño.",
    a:[["Pedir propuesta",waTexto("Hola, busco un pastel para pocas personas con un diseño bonito. Somos:"),"primario"],["Ver el catálogo","/collections/all","secundario"]] }
};

/* --- Temas: cuando preguntan por un pastel, se les lleva al catálogo. --- */
var TEMAS = [
  { k:"star wars, starwars, baby yoda, darth vader, jedi", n:"Star Wars", u:"/collections/pastel-de-star-wars" },
  { k:"harry potter, hogwarts, magia", n:"Harry Potter", u:"/collections/pasteles-de-harry-potter" },
  { k:"paw patrol, patrulla canina", n:"Paw Patrol", u:"/collections/pastel-de-paw-patrol" },
  { k:"spiderman, hombre araña, arana", n:"Spider-Man", u:"/collections/pastel-de-spiderman" },
  { k:"batman", n:"Batman", u:"/collections/pasteles-de-batman" },
  { k:"super heroes, superheroes, avengers, marvel", n:"superhéroes", u:"/collections/pastel-de-super-heroes" },
  { k:"mickey, minnie, disney", n:"Mickey y Minnie", u:"/collections/pasteles-de-mickey-y-minnie-mouse" },
  { k:"unicornio, unicornios", n:"unicornio", u:"/collections/pasteles-de-unicornio" },
  { k:"mario bros, mario, luigi", n:"Mario Bros", u:"/collections/pasteles-de-mario-bros" },
  { k:"fortnite", n:"Fortnite", u:"/collections/pasteles-de-fortnite" },
  { k:"minecraft", n:"Minecraft", u:"/collections/pasteles-de-minecraft" },
  { k:"frozen, elsa, olaf", n:"Frozen", u:"/collections/pasteles-de-frozen" },
  { k:"bob esponja", n:"Bob Esponja", u:"/collections/pasteles-de-bob-esponja" },
  { k:"goku, dragon ball", n:"Goku", u:"/collections/pasteles-de-goku" },
  { k:"stranger things", n:"Stranger Things", u:"/collections/pasteles-de-stranger-things" },
  { k:"princesa, princesas", n:"princesas", u:"/collections/pasteles-de-princesas" },
  { k:"dinosaurio, dinosaurios, dino", n:"dinosaurios", u:"/collections/pasteles-de-dinosaurio" },
  { k:"barbie", n:"Barbie", u:"/collections/pasteles-de-barbie" },
  { k:"memes, meme", n:"memes", u:"/collections/pasteles-de-memes" },
  { k:"3d, tres dimensiones, esculpido", n:"3D", u:"/collections/3d" },
  { k:"boda, bodas, casamiento, novios", n:"boda", u:"/collections/boda" },
  { k:"xv, quince, quinceanera, quince años", n:"XV años", u:"/collections/xv-anos" },
  { k:"cumpleanos, cumple, birthday", n:"cumpleaños", u:"/collections/cumpleanos" },
  { k:"infantil, infantiles, niño, nina, niños", n:"infantiles", u:"/collections/infantiles" },
  { k:"baby shower", n:"baby shower", u:"/collections/baby-shower" },
  { k:"bautizo, bautismo", n:"bautizo", u:"/collections/pasteles-para-bautizo" },
  { k:"primera comunion, comunion", n:"primera comunión", u:"/collections/pasteles-de-primera-comunion" },
  { k:"graduacion, graduaciones", n:"graduación", u:"/collections/graduacion" },
  { k:"despedida, despedida de soltera", n:"despedida", u:"/collections/despedida" },
  { k:"corporativo, empresa, logo, marca", n:"corporativos", u:"/collections/corporativos" },
  { k:"luxury, lujo, premium", n:"luxury cakes", u:"/collections/luxury-cakes" },
  { k:"primer ano, primer año, un anito, 1 año", n:"primer año", u:"/collections/pasteles-para-el-primer-ano-de-bebe" },
  { k:"halloween, dia de muertos, muertos", n:"Halloween y Día de Muertos", u:"/collections/pasteles-de-halloween-y-de-dia-de-muertos" },
  { k:"navidad, navideno, año nuevo, ano nuevo", n:"Navidad y Año Nuevo", u:"/collections/pasteles-navidenos-y-de-ano-nuevo" },
  { k:"rosca, reyes, rosca de reyes", n:"Rosca de Reyes", u:"/collections/rosca-de-reyes" },
  { k:"san valentin, valentin, amor y amistad", n:"San Valentín", u:"/collections/pasteles-de-san-valentin" },
  { k:"dia de las madres, mama, madres", n:"Día de las Madres", u:"/collections/pasteles-del-dia-de-las-madres" },
  { k:"dia del padre, papa, padres", n:"Día del Padre", u:"/collections/pasteles-del-dia-del-padre" },
  { k:"dia del nino", n:"Día del Niño", u:"/collections/pasteles-del-dia-del-nino" },
  { k:"pride, lgbt, arcoiris", n:"Pride", u:"/collections/pasteles-pride-lgbttiq" },
  { k:"pascua, conejo de pascua", n:"Pascua", u:"/collections/pasteles-de-pascua" },
  { k:"aesthetic, pantone, coquette", n:"aesthetic", u:"/collections/baking-the-pantone-aesthetic-cakes" },
  { k:"cupcake, cupcakes", n:"cupcakes", u:"/collections/otros-productos" },
  { k:"fondant, decorar", n:"fondant y artículos para decorar", u:"/collections/fondant" },
  { k:"linea a domicilio, de linea, cheesecake, nutella", n:"pasteles de línea", u:"/collections/pasteles-de-linea-a-domicilio" },
  { k:"regalo, regalar, detalle", n:"para regalar", u:"/collections/de-ocasion-para-regalar" }
];

function ctaDe(a){ return CTA_ART[a.id] || CTA_CAT[a.cat]; }

/* Se exponen para kb.js, que vive en otro archivo. */
window.KB_TEMAS = TEMAS;
window.ctaDe = ctaDe;
window.waTexto = waTexto;
window.aFlotante = aFlotante;
window.pideVendedor = pideVendedor;
window.WA_NUMEROS = WA_NUMEROS;
